import React, { useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import NoChannelBanner from "../NoChannelBanner";
import {
  WelcomeCard,
  UnattendedCard,
  ContactsOverviewCard,
  LifecyclePipeline,
  ContactsPanel,
  TeamMembersPanel,
} from "./components";
import {
  STAGES_PER_PAGE,
  CHANNEL_ICON,
  STATUS_COLOR,
  STATUS_ICONS,
} from "./constants";
import { fetchUnattendedStats } from "../../../redux/Slice/Dashboard/dashboardSlice";
import { slimScrollbarSx } from "../../../utils/scrollbarStyles";

// Scratch/isolated page for redesigning the Dashboard UI.
// Most sections are still hardcoded placeholder data (no Redux, no API calls) and get wired up
// as each one is finalized — ContactsOverviewCard, LifecyclePipeline, TeamMembersPanel and
// UnattendedCard are wired to real data already (see each component). Once the whole page is
// finalized, this gets copied into Dashboard.jsx.

function DashboardScratch() {
  const theme = useTheme();
  const dispatch = useDispatch();

  const unattendedStats = useSelector((state) => state.dashboard.unattendedStats);
  const unattendedLoading = useSelector((state) => state.dashboard.loading.unattendedStats);
  const currentWorkspace = useSelector((state) => state.workspace?.currentWorkspace);
  const authUser = useSelector((state) => state.auth?.user);
  const authWorkspaceId = authUser?.workspaceId;
  const workspaceId = currentWorkspace?._id || authWorkspaceId;
  const userName = authUser?.name || authUser?.email || "User";

  useEffect(() => {
    if (!workspaceId) return;
    dispatch(fetchUnattendedStats());
  }, [dispatch, workspaceId]);

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        p: 3,
        boxSizing: "border-box",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        // This is the REAL live Dashboard (routed in App.js — Dashboard.jsx is
        // dead code, confirmed 2026-08-19) and had no custom scrollbar at all,
        // silently falling back to index.css's plain global rule. Now matches
        // Inbox's shared formula.
        ...slimScrollbarSx,
      }}
    >
      {/* <Box sx={{ mb: 3 }}>
        <NoChannelBanner titleFontSize="1.125rem" subtitleFontSize="0.8125rem" />
      </Box> */}

      <Box sx={{ display: "flex", gap: 2 }}>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2, height: 440 }}>
          <WelcomeCard userName={userName} />
          <UnattendedCard
            count={unattendedStats?.count}
            oldestWaitingAt={unattendedStats?.oldestWaitingAt}
            loading={unattendedLoading}
          />
        </Box>
        <ContactsOverviewCard />
        <LifecyclePipeline stagesPerPage={STAGES_PER_PAGE} />
      </Box>

      <Box sx={{ display: "flex", gap: 2, mt: "-44px" }}>
        <ContactsPanel channelIcons={CHANNEL_ICON} statusColor={STATUS_COLOR} />
        <TeamMembersPanel statusIcons={STATUS_ICONS} />
      </Box>
    </Box>
  );
}

export default DashboardScratch;
